var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closeDropdown,
          expression: "closeDropdown",
        },
      ],
      staticClass: "bb-dropdown",
    },
    [
      _c(
        "div",
        {
          staticClass: "bb-dropdown-toggle",
          on: { click: _vm.toggleDropdown },
        },
        [
          _vm._t(
            "toggle",
            function () {
              return [_c("span", [_vm._v(_vm._s(_vm.toggleBtnText))])]
            },
            { toggleDropdown: _vm.toggleDropdown, isOpen: _vm.isOpen }
          ),
        ],
        2
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isOpen,
              expression: "isOpen",
            },
          ],
          staticClass: "bb-dropdown-content",
          class: _vm.positionClass,
        },
        [
          _c(
            "div",
            { staticClass: "bb-dropdown-items-container" },
            [
              _vm._t(
                "items",
                function () {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("defaults.dropdown.description"))),
                    ]),
                  ]
                },
                { closeDropdown: _vm.closeDropdown }
              ),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }